import React from "react";
import styles from "./styles/RightSection.module.scss";
// Shared components between footers
import SocialMedia from "../../shared-components/SocialMedia";
// Utils
import images from "../../../../../utils/images";
import footerConfigs from "../../../../../utils/configs/footer";
import tempMedia from "../../../../../assets/temp/tempMedia";

const RightSection = () => {
  return (
    <section className={styles["right-section"]}>
      <div className={styles.header}>
        <div>
          <img alt={"Site logo"} src={images.siteLogo} />
          <p>صرافی طلا</p>
        </div>
        <img alt={"Neshane melli sabt"} src={tempMedia.neshaneMelliSabt} />
      </div>

      <div className={styles["social-media"]}>
        <p>شبکه‌های اجتماعی</p>
        <div>
          {footerConfigs.socialMedia.map((item) => (
            <SocialMedia key={item.title} data={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RightSection;
